import apiService from "../common/commonApi";

export const position = {};

position.list = async (param) => {    
    return apiService.Get('position-list', param);
}

position.add = async (param) => {    
    return apiService.Post('position-create', param);
}

position.delete = async (param) => {    
    return apiService.Post('position-delete', param);
}

position.update = async (param) => {    
    return apiService.Post('position-update', param);
}